import accountId from './accountId/accountIdSlice';
import dealerPhoto from './dealerPhoto/dealerPhotoSlice';

const root = {
	accountId,
	dealerPhoto
};

export default root;
